import React from 'react';
import Icon from './Icon';

export default class ModuleWebinar extends Icon {
  render() {
    let { color, size, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 250 250.05"
        {...props}
      >
        <g fill={color}>
          <path d="M190.75 158.55a3.37 3.37 0 01-1.6-.41L153.53 139a3.38 3.38 0 013.21-6l30.64 16.5v-49L156.74 117a3.38 3.38 0 11-3.21-5.94l35.62-19.18a3.37 3.37 0 015 3v60.28a3.37 3.37 0 01-3.38 3.38z" />
          <path d="M144.18 169.51h-74a14.37 14.37 0 01-14.34-14.34V94.89A14.37 14.37 0 0170.2 80.55h74a14.37 14.37 0 0114.34 14.34V114a3.38 3.38 0 01-6.76 0v-6.4V94.89a7.59 7.59 0 00-7.58-7.58h-74a7.59 7.59 0 00-7.58 7.58v60.28a7.59 7.59 0 007.58 7.58h74a7.59 7.59 0 007.58-7.58v-19a3.38 3.38 0 016.76 0v19a14.37 14.37 0 01-14.36 14.34z" />
          <path d="M127.14 250.05h-2.29c-27.18-.41-52.63-8.71-73.61-24A124.66 124.66 0 010 125.12c.11-24.57 7.46-47.73 21.85-68.82a133.39 133.39 0 0126.22-28.61C76.94 4.83 108.54.68 124.81.24L231.27 0a17.56 17.56 0 0113.32 5.58 17.92 17.92 0 014.26 10.15c1 9 1.42 52 1 109.44v.08a155.05 155.05 0 01-8.37 43.11c-9.59 27.86-25.68 49.16-47.8 63.3-19.15 12.21-41.51 18.39-66.54 18.39zM231.69 6.76h-.35L124.91 7c-15.34.42-45.31 4.35-72.64 26C44.71 39 7 71.54 6.76 125.15a117.86 117.86 0 0048.46 95.43c19.84 14.46 44 22.32 69.73 22.7 24.62.38 46.49-5.46 65-17.31 49.24-31.47 52.81-93.68 53.06-100.9.45-56.3.09-99.92-.91-108.56a11.2 11.2 0 00-2.57-6.41 10.83 10.83 0 00-7.84-3.34z" />
        </g>
      </svg>
    );
  }
}




// WEBPACK FOOTER //
// ./src/js/components/Icons/ModuleWebinar.js